<script>
import DateStrip from '@/components/picker/date-strip.vue'
import { mapActions, mapGetters } from 'vuex'
import dayjs from '@/services/date'
import baseMixin from '@/mixins/baseMixin'

export default {
  components: {
    DateStrip,
  },
  mixins: [baseMixin],
  props: {
    refreshData: {
      type: Boolean,
    },
    selectedDay: {
      type: Object,
      default: () => dayjs(),
    },
  },
  data() {
    return {
      initialLoad: false,
      year: null,
      month: null,
      bookingOverview: [],
      reRenderDateStrip: false,
    }
  },
  computed: {
    ...mapGetters({
      getSelectedClients: 'client/getSelectedClients',
    }),
  },
  watch: {
    refreshData: {
      async handler() {
        if (this.refreshData) {
          await this.loadSummaryData()
          this.$emit('refreshComplete')
        }
      },
    },
  },
  created() {
    // Ensure the month and year are set on init to ensure the dashboard fill rate stats are set correctly
    this.changeMonth(dayjs().month(), false)
    this.changeYear(dayjs().year())
  },
  methods: {
    ...mapActions({
      loadYearOfBookingOverviewData: 'bookings/loadYearOfBookingOverviewData',
    }),
    async loadSummaryData() {
      const result = await this.loadYearOfBookingOverviewData({
        year: this.year,
        clientIds: this.getSelectedClients,
      })

      if (!result.isSuccess) return

      this.bookingOverview = result.data

      if (!this.initialLoad) {
        this.initialLoad = true

        const dateString = dayjs().format('YYYY-MM-DD')
        // eslint-disable-next-line no-unused-vars
        let bookingCount = 0
        const todaysRecord = this.bookingOverview.filter(
          (t) => t.dateLocal === dateString + 'T00:00:00'
        )

        if (todaysRecord.length === 1) {
          bookingCount = todaysRecord[0].totalBookingsCount
        }

        this.$emit('dateSelected', dateString, bookingCount)
      }
    },
    async changeYear(year) {
      this.year = year

      await this.loadSummaryData()

      this.$emit('yearChanged', dayjs({ year: this.year, month: this.month }))
    },
    changeMonth(month, shouldEmitChanges = true) {
      this.month = month

      if (shouldEmitChanges)
        this.$emit(
          'monthChanged',
          dayjs({ year: this.year, month: this.month })
        )
    },
    dateSelected(dateObject, nItems) {
      this.$emit('dateSelected', dateObject, nItems)
    },
    getToday() {
      return dayjs().format('YYYY-MM-DD')
    },
  },
}
</script>

<template>
  <div>
    <div :class="[isSmallOrLower ? '' : 'ml-n3']">
      <v-btn icon @click="changeYear(year - 1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      {{ year }}
      <v-btn icon @click="changeYear(year + 1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>

    <DateStrip
      :bookings="bookingOverview"
      :year="year"
      :selected-day="
        selectedDay ? selectedDay.format('YYYY-MM-DD') : getToday()
      "
      @monthChanged="changeMonth"
      @dateSelected="dateSelected"
    />
  </div>
</template>
